import { useNavigate } from 'react-router';

import EmptyableCard from '../../../../components/Card/EmptyableCard';
import PostedJobsCard from '../../../../components/Card/PostedJobsCard';
import { IGetCreatedJobs } from '../../../../models/dashboard/jobs/getCreatedJobs.model';
import { useAppSelector } from '../../../../redux/store';
import {
  DASHBOARD,
  MANAGE_POSTED_JOBS,
} from '../../../../routes/routeConstants';
import styled from '@emotion/styled';
import { Modal } from '../../../../components/Modals/Modal';
import { ModalProvider } from '../../../../context/ModalContext';
import ModalTriggerContainer from '../../../../components/Modals/ModalTriggerContainer';
import PostJobModal from '../../../../components/Modals/ModalsActions/PostJobModal';
import useGetCreatedJobPosts from '../../../../hooks/dashboard/jobs/useGetCreatedJobPosts';
import { useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { usePostedJobsPage } from '../../../../context/PostedJobsPageContext';

const YourPostedJobs = () => {
  const navigate = useNavigate();
  const { loading, getCreatedJobPosts } = useGetCreatedJobPosts();

  const { currentPage, clearPage, setKeyword, keyword } = usePostedJobsPage();

  // useEffect(() => {
  //   if (currentPage === 1) {
  //     clearPage();
  //   }
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if (currentPage !== 1 || keyword) {
      setKeyword('');
      clearPage();
      getCreatedJobPosts();
    }
    // eslint-disable-next-line
  }, []);

  const jobsCreatedList = useAppSelector((state) => state.jobsCreatedList);

  const handleViewAll = () => {
    navigate(`/${DASHBOARD}/${MANAGE_POSTED_JOBS}`);
  };

  const ShowPostJobModal = ({ children }: { children: React.ReactNode }) => {
    return (
      <ModalProvider>
        <ModalTriggerContainer>
          <Viewnote>
            You currently don't have any posted jobs,<span> {children} </span>{' '}
            to get started
          </Viewnote>
        </ModalTriggerContainer>
        <Modal>
          <PostJobModal />
        </Modal>
      </ModalProvider>
    );
  };

  return (
    <EmptyableCard
      label="Your Posted Jobs"
      emptyViewNote={<ShowPostJobModal>click here</ShowPostJobModal>}
      viewAllClick={handleViewAll}
    >
      {loading ? (
        <LoadingOutlined />
      ) : (
        jobsCreatedList.jobData?.map((data: IGetCreatedJobs, index) => (
          <PostedJobsCard key={index} job={data} />
        ))
      )}
    </EmptyableCard>
  );
};

export default YourPostedJobs;

const Viewnote = styled.span`
  font-size: 18px;
  font-weight: 400;
  line-height: 26.91px;
  letter-spacing: -1px;

  & > div {
    text-align: left;
  }

  & > span {
    color: ${({ theme }) => theme.palette.mainBlue};
  }
`;
